import React from 'react';
import { ErrorData } from './ErrorMessage.interface';
import { Alert } from '@toctoc/design-system';

export const ErrorMessage: React.FC<ErrorData> = ({ errorData }) => {
	return (
		<div className='userErrorAlertCtr'>
			<Alert 
				severity='error'
				variant='standard'
				className='userErrorAlert'
			>
				<div className='messageCtr'>
					{errorData.map((x, index) => x.clickable ? <a key={`a-${index}`} href={x.href}>{x.text}</a> : <span key={`s-${index}`}>{x.text}</span>)}
				</div>
			</Alert>
		</div>
	)
}
export default ErrorMessage;